module.exports = __webpack_public_path__ + "img/wfh.f7edf3d0.png";